import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class Attribute extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(Attribute, v) : SKIP;
            },
            (v) => {
                return deserialize(Attribute, v) || new Attribute();
            }
        );
    }

    constructor() {
        super();
        this._key = null;
        this._value = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get value() {
        return this._value;
    }

    set value(value) {
        this._value = value;
    }

    valid() {
        if (!this.key || this.key.length === 0) {
            return false;
        }

        if (!this.value || this.value.length === 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.value || this.value.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Attribute());
        } else if (target instanceof Attribute) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Attribute, {
    _key: alias("key", Schema.primitive()),
    _value: alias("value", Schema.primitive())
});